import { apiRequest } from './apiClient';
import { sanitizeSearchInput } from '../utils/security';

const FAILURE_BLOCK_DURATION_MS = 1000 * 60; // 60 saniye

/** Genel city/district cache */
let cachedCitiesSelect = null;
let citiesSelectCacheExpiry = 0;
let citiesFailureBlock = null;

const cachedDistrictsByCity = {};
const districtFailureBlocks = {};

/**
 * İl listesini getirir (select için)
 */
export const fetchCities = async ({ bolge, aktif = true } = {}) => {
  const queryParams = {};
  if (bolge && bolge.trim()) {
    queryParams.bolge = sanitizeSearchInput(bolge);
  }

  if (aktif === false) {
    queryParams.aktif = 'false';
  }

  const hasQueryParams = Object.keys(queryParams).length > 0;

  if (!hasQueryParams && aktif === true) {
    const now = Date.now();
    if (citiesFailureBlock && citiesFailureBlock.until > now) {
      throw citiesFailureBlock.error;
    }
    if (cachedCitiesSelect && citiesSelectCacheExpiry > now) {
      return cachedCitiesSelect;
    }

    try {
      const response = await apiRequest('/api/locations/cities/select', {
        method: 'GET',
        skipCsrf: true,
      });
      cachedCitiesSelect = response;
      citiesSelectCacheExpiry = now + 1000 * 60;
      citiesFailureBlock = null;
      return response;
    } catch (error) {
      citiesFailureBlock = { error, until: now + FAILURE_BLOCK_DURATION_MS };
      throw error;
    }
  }

  return apiRequest('/api/locations/cities/select', {
    method: 'GET',
    query: hasQueryParams ? queryParams : undefined,
    skipCsrf: true,
  });
};

/**
 * İle göre ilçeleri getirir
 */
export const fetchDistrictsByCity = async (cityId) => {
  if (!cityId) {
    throw new Error('İl ID gereklidir');
  }
  const cityKey = String(cityId);
  const now = Date.now();
  const failureBlock = districtFailureBlocks[cityKey];
  if (failureBlock && failureBlock.until > now) {
    throw failureBlock.error;
  }
  if (cachedDistrictsByCity[cityKey]) {
    return cachedDistrictsByCity[cityKey];
  }
  try {
    const response = await apiRequest(`/api/locations/cities/${cityKey}/districts`, {
      method: 'GET',
      skipCsrf: true,
    });
    cachedDistrictsByCity[cityKey] = response;
    if (failureBlock) {
      delete districtFailureBlocks[cityKey];
    }
    return response;
  } catch (error) {
    districtFailureBlocks[cityKey] = { error, until: now + FAILURE_BLOCK_DURATION_MS };
    throw error;
  }
};

/**
 * İlçe listesini getirir (select için)
 */
export const fetchDistricts = async ({ cityId, aktif = true } = {}) => {
  const queryParams = {};
  
  if (cityId) {
    queryParams.cityId = parseInt(cityId, 10);
  }
  
  // aktif parametresini sadece false ise gönder, varsayılan true olduğu için
  if (aktif === false) {
    queryParams.aktif = 'false';
  }
  
  return apiRequest('/api/locations/districts/select', {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * İl detayı ve ilçeleri getirir
 */
export const fetchCityDetail = async (id) => {
  if (!id) {
    throw new Error('İl ID gereklidir');
  }
  return apiRequest(`/api/locations/cities/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * İl arama
 */
export const searchCities = async (arama) => {
  if (!arama || arama.trim().length < 2) {
    throw new Error('Arama terimi en az 2 karakter olmalıdır');
  }
  return apiRequest('/api/locations/cities/search', {
    method: 'GET',
    query: {
      arama: sanitizeSearchInput(arama),
    },
    skipCsrf: true,
  });
};

/**
 * İlçe arama
 */
export const searchDistricts = async (arama, cityId = null) => {
  if (!arama || arama.trim().length < 2) {
    throw new Error('Arama terimi en az 2 karakter olmalıdır');
  }
  return apiRequest('/api/locations/districts/search', {
    method: 'GET',
    query: {
      arama: sanitizeSearchInput(arama),
      cityId: cityId ? parseInt(cityId, 10) : undefined,
    },
    skipCsrf: true,
  });
};

